export default {
  namespaced: true,

  state: {
    data: {
      modalImageIndex: 0
    }
  },

  getters: {
    getData: state => state.data
  },

  mutations: {
    put(state, { key, value }) {
      state.data[key] = value;
    }
  },

  actions: {
    fill({ commit }, data) {
      commit('fill', data);
    },

    put({ commit }, data) {
      commit('put', data);
    }
  }
};



// WEBPACK FOOTER //
// ./resources/components/store/modules/slick.js